import React, { useMemo } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createTheme, ThemeProvider } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

const RootComponent = () => {
  // ✅ ThemeProvider 최적화 (useMemo 사용)
  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          primary: {
            main: "#1976d2",
          },
          secondary: {
            main: "#ff4081",
          },
        },
        typography: {
          fontFamily: "Arial",
        },
      }),
    []
  );

  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  );
};

// ✅ React 18 방식 적용
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <RootComponent /> // ✅ StrictMode 제거 상태 유지 (테스트 시 필요하면 추가 가능)
);

// ✅ 성능 측정 (옵션)
reportWebVitals();